module.exports = __webpack_public_path__ + "static/img/demo.34506fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/demo.png
// module id = F4g0
// module chunks = 1